import { render } from "./EditShop.vue?vue&type=template&id=79d9c1f3"
import script from "./EditShop.vue?vue&type=script&lang=js"
export * from "./EditShop.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__